import React from "react";
import { CreditCard, Lock } from "lucide-react";

export const isStripeUrl = (u) =>
  /^https:\/\/(buy|checkout|donate)\.stripe\.com\//i.test((u || "").trim());

// Botón "Comprar ahora" que abre el Payment Link de Stripe del cliente.
export const BuyButton = ({ href, label, small = false, className = "", onClick }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    className={`inline-flex items-center justify-center gap-2 rounded-xl bg-[#635BFF] font-semibold text-white shadow-[0_8px_22px_rgba(99,91,255,.35)] transition hover:brightness-110 active:scale-95 ${
      small ? "px-3 py-1.5 text-xs" : "w-full py-2.5 text-sm"
    } ${className}`}
    data-testid="buy-now-btn"
  >
    <CreditCard className={small ? "h-3.5 w-3.5" : "h-4 w-4"} />
    {label || "Comprar ahora"}
  </a>
);

// Campo del editor para pegar el Payment Link de Stripe.
export const PayLinkField = ({ value, onChange, InputCmp }) => {
  const v = value || "";
  const bad = v && !isStripeUrl(v);
  return (
    <div className="space-y-1 rounded-lg bg-indigo-50/70 p-2">
      <p className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-indigo-500">
        <CreditCard className="h-3.5 w-3.5" /> Pago con tarjeta (Stripe, opcional)
      </p>
      <InputCmp
        placeholder="Link de pago Stripe (https://buy.stripe.com/...)"
        value={v}
        onChange={(e) => onChange(e.target.value.trim())}
        data-testid="paylink-input"
      />
      <p className={`text-[11px] ${bad ? "text-red-500" : "text-slate-400"}`}>
        {bad
          ? "Debe ser un enlace de Stripe (buy.stripe.com o checkout.stripe.com)."
          : "Si lo llenas, aparece el botón “Comprar ahora”. El dinero llega directo a tu cuenta Stripe. Configura la página de gracias en los datos del portafolio."}
      </p>
    </div>
  );
};

export const PayBlock = ({ block, SectionHeading }) => {
  const ok = isStripeUrl(block.payLink);
  return (
    <div className="w-full" data-testid="pay-block">
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.06] p-5 backdrop-blur">
        {block.title && (
          <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>
        )}
        {block.description && (
          <p className="mt-2 text-center text-sm leading-relaxed text-white/65">{block.description}</p>
        )}
        {block.price && (
          <p className="mt-3 text-center font-display text-3xl font-bold text-white" data-testid="pay-price">
            {block.price}
          </p>
        )}
        <div className="mt-4">
          {ok ? (
            <BuyButton href={block.payLink.trim()} label={block.btnLabel || "Pagar con tarjeta"} />
          ) : (
            <p className="text-center text-xs text-white/40">Agrega tu link de pago de Stripe en el editor.</p>
          )}
        </div>
        <p className="mt-3 flex items-center justify-center gap-1.5 text-[11px] text-white/45">
          <Lock className="h-3 w-3" /> Pago seguro con Stripe · Visa · Mastercard · Amex
        </p>
      </div>
    </div>
  );
};
